import Tippy from '@tippyjs/react'
import { selectCurrentHotelId } from 'accessors'
import RefreshIcon from 'components/ReusableComponents/RefreshIcon'
import moment from 'moment'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'

import CallIcon from '../../../components/ReusableComponents/Icons/Call'
import SmsIcon from '../../../components/ReusableComponents/Icons/Sms'
import { formatPhoneNumber } from '../../../utils/helpers'
import Box from '../Box/index'
import styles from './PhoneNumbers.module.scss'

const CapabilityIcon = ({ capability }) => {
  if (capability === 'VoiceAndText') {
    return (
      <span>
        <CallIcon /> <SmsIcon />
      </span>
    )
  }

  if (capability === 'TextOnly') {
    return (
      <span>
        <SmsIcon />
      </span>
    )
  }

  return null
}

const Number = ({ capability, phoneNumber, provider, status, addedOn, isPrimary }) => (
  <div className={styles.numberHolder}>
    <div className={styles.left}>
      <Tippy content={`Added on: ${moment(addedOn).format('MMM DD, YYYY h:MM A')}`}>
        <span className={styles.number}>{formatPhoneNumber(phoneNumber)}</span>
      </Tippy>
      <div className={styles.leftSecondary}>
        {isPrimary && <span className={styles.primary}>Primary</span>}
        <span className={[styles.status, styles[`status-${status}`]].join(' ')}>
          {status}
        </span>
        <span className={styles.provider}>{provider}</span>
      </div>
    </div>
    <div className={styles.right}>
      <CapabilityIcon capability={capability} />
    </div>
  </div>
)

const PhoneNumbers = ({ numbers, telecomProvider, handleReload }) => {
  const currentHotelId = useSelector(selectCurrentHotelId)

  return (
    <div className={styles.wrapper}>
      <Box title="Proxy numbers">
        <div className={styles.subtitle}>Provider: {telecomProvider}</div>
        <button className={styles.refreshButton} onClick={() => handleReload()}>
          <RefreshIcon />
        </button>
        {numbers
          .sort(a => (a.isPrimary ? -1 : 1))
          .map(p => (
            <Number {...p} key={p.phoneNumber} />
          ))}

        {numbers && numbers.length === 0 && (
          <div className={styles.noNumbers}>No numbers</div>
        )}
        <br />
        {numbers.length !== 0 && (
          <Link to={`/addTelecom/${currentHotelId}`}>Buy another phone number</Link>
        )}
      </Box>
    </div>
  )
}

export default PhoneNumbers
